<template>
    <v-container grid-list-xs fluid>
        <v-card min-height="800px">
            <v-toolbar color="primary" dense dark>
                <v-spacer></v-spacer>
                <h3>Dynamic Report</h3>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row justify="center">
                    <v-col cols="3">
                        <v-text-field
                            id="StartDate"
                            name="Start Time"
                            label="Start Time"
                            v-mask="'####-##-##'"
                            placeholder="YYYY-MM-DD"
                            v-model="$store.state.load.StartTime"
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <v-text-field
                            id="EndDate"
                            name="Start Time"
                            label="End Time"
                            v-mask="'####-##-##'"
                            placeholder="YYYY-MM-DD"
                            v-model="$store.state.load.EndTime"
                            dense
                        ></v-text-field>
                    </v-col>

                    <v-col cols="2">
                        <v-btn
                            color="primary"
                            class="mt-2"
                            small
                            @click="report"
                            >Report</v-btn
                        >
                    </v-col>
                </v-row>
            </v-container>
            <v-container grid-list-xs>
                <v-row class="mx-5">
                    <v-col lg="3" md="3" sm="4">
                        <v-combobox
                            v-model="station"
                            :items="stations"
                            :item-text="'Name'"
                            :item-value="'id'"
                            label="Station"
                            class="mx-3"
                            dense
                            auto-select-first
                            hide-details
                        ></v-combobox>
                    </v-col>
                    <v-col lg="3" md="3" sm="4">
                        <v-combobox
                            v-model="terminal"
                            :items="terminals"
                            :item-text="'Name'"
                            :item-value="'id'"
                            label="Terminal"
                            class="mx-3"
                            dense
                            auto-select-first
                            hide-details
                        ></v-combobox>
                    </v-col>
                    <v-col lg="3" md="3" sm="4">
                        <v-combobox
                            v-model="driver"
                            :items="drivers"
                            :item-text="'Name'"
                            :item-value="'id'"
                            label="Driver"
                            class="mx-3"
                            dense
                            auto-select-first
                            hide-details
                        ></v-combobox>
                    </v-col>
                    <v-col lg="3" md="3" sm="4">
                        <v-combobox
                            dense
                            v-model="truck"
                            :items="trucks"
                            :item-text="'Truck'"
                            :item-value="'id'"
                            label="Truck"
                            class="mx-3"
                            auto-select-first
                            hide-details
                        ></v-combobox>
                    </v-col>
                    <v-col lg="3" md="3" sm="4">
                        <v-combobox
                            v-model="trailer"
                            :items="trailers"
                            :item-text="'Trailer'"
                            :item-value="'id'"
                            label="Trailer"
                            dense
                            class="mx-3"
                            hide-details
                        ></v-combobox>
                    </v-col>
                    <v-col lg="3" md="3" sm="4">
                        <v-combobox
                            v-model="customer"
                            :items="customers"
                            :item-text="'Name'"
                            :item-value="'id'"
                            label="Customer"
                            class="mx-3"
                            dense
                            auto-select-first
                            hide-details
                        ></v-combobox>
                    </v-col>
                    <v-col lg="3" md="3" sm="4">
                        <v-combobox v-model="productType" :items="products" :item-text="'Product'"
                        class="mx-3"  @change="selectProduct"   :item-value="'ProductID'" auto-select-first dense hide-details></v-combobox>
                    </v-col>
                    <v-col lg="3" md="3" sm="4">
                        <v-checkbox class="float-left mr-2" label="Rate/Kms" @change="headerChange" dense v-model="Rate"></v-checkbox>
                        <v-checkbox class="float-left mx-2" label="Product Qty" @change="headerChange" dense v-model="Product"></v-checkbox>
                        <v-checkbox class="float-left ml-2" label="InvId/PayId"  @change="headerChange" dense v-model="InvPay"></v-checkbox>
                    </v-col>
                </v-row>
            </v-container>
            <v-container grid-list-xs fluid>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="filteredItems"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    class="elevation-1"
                    @update:sort-by="updateSortBy"
                    @update:sort-desc="updateSortDesc"
                    fixed-header
                    height="600px"
                >
                    <template v-slot:top>
                        <v-row>
                            <v-col cols="4">
                                <v-text-field
                                    label="Search"
                                    hide-details
                                    dense
                                    v-model="search"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-combobox
                                    v-model="fil"
                                    label="Filter"
                                    :items="filters"
                                    hide-details
                                    dense
                                    item-text="val"
                                    @change="filterData()"
                                ></v-combobox>
                            </v-col>
                            <v-col cosl="1">
                                <v-btn
                                    color="success"
                                    icon
                                    @click="reportDownload"
                                    ><v-icon>mdi-microsoft-excel</v-icon></v-btn
                                >
                            </v-col>
                        </v-row>
                    </template>
                </v-data-table>
            </v-container>
        </v-card>
    </v-container>
</template>
<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
export default {
    directives: { mask },
    data: function() {
        return {
            customers: [],
            terminals: [],
            stations: [],
            drivers: [],
            trailers: [],
            trucks: [],
            customer: null,
            terminal: null,
            station: null,
            driver: null,
            trailer: null,
            truck: null,
            preview: [],
            search: '',
            show: false,
            Rate: false,
            InvPay: false,
            Product: false,
            fil: null,
            filters: [
                 'Date' ,
                 'ShiftDetail' ,
                 'DriverName' ,
                 'OrderID' ,
                 'BillOfLading' ,
                 'TerminalName' ,
                 'StationName' ,
                 'CustomerName' ,
            ],
            products:[],
            productType:[],
            sortBy: null, // Default field for sorting
            sortDesc: null, // Default ascending order
            headers: [
                { text: 'Date', value: 'Date' },
                { text: 'Shift', value: 'Shift' },
                { text: 'ShiftDetail', value: 'ShiftDetail' },
                { text: 'Driver', value: 'DriverName' },
                { text: 'Truck', value: 'Truck' },
                { text: 'Trailer', value: 'Trailer' },
                { text: 'Order', value: 'OrderID' },
                { text: 'BOL', value: 'BillOfLading' },
                { text: 'L1', value: 'LoadNum' },
                { text: 'L2', value: 'LoadNumOrd' },
                { text: 'Terminal', value: 'TerminalName' },
                { text: 'Station', value: 'StationName' },
                { text: 'Customer', value: 'CustomerName' }
            ]
        };
    },
    mounted() {
        this.loadTrucks();
        this.loadTrailers();
        this.loadDrivers();
        this.loadStations();
        this.loadCustomers();
        this.loadTerminals();
        this.loadAllProducts();
    },
    computed: {
        filteredItems() {
            return this.preview.filter(i => {
                const search = new RegExp(this.search, 'i');
                return !this.search || search.test(i[this.fil]);
            });
        }
    },
    methods: {
        selectProduct: function (){
            if(this.productType == null){
                
            }else{
                this.Product = true;
                this.headerChange();
            }
        },
        loadTrucks: function () {
            this.$store.state.isLoading = true;
            var str = this.$store;
            if (this.trucks.length == 0) {
                axios
                    .get('truck/active', {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        this.trucks = response.data;
                        console.log(this.trucks);
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }
            this.$store.state.isLoading = false;
        },
        loadTrailers: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get('trailer')
                .then(response => {
                    this.trailers = response.data.data;
                    this.dataLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        loadStations: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('station/active')
                .then(response => {
                    this.stations = response.data.data;
                    console.log(this.stations);
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        loadTerminals: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('terminal/active')
                .then(response => {
                    this.terminals = response.data.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        loadDrivers: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get('driver')
                .then(response => {
                    this.drivers = response.data.data;
                    console.log(this.drivers);
                    this.dataLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        loadCustomers: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('customer/active')
                .then(response => {
                    console.log(response.data.data);
                    this.customers = response.data.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
            str.state.isLoading = false;
        },
        loadAllProducts: function () {
            this.$store.state.isLoading = true;
            axios
                .get('product/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.products = response.data.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        headerChange:async function (){
            this.headers.length = 0;
            this.headers = [
                { text: 'Date', value: 'Date' },
                { text: 'Shift', value: 'Shift' },
                { text: 'ShiftDetail', value: 'ShiftDetail' },
                { text: 'Driver', value: 'DriverName' },
                { text: 'Truck', value: 'Truck' },
                { text: 'Trailer', value: 'Trailer' },
                { text: 'Order', value: 'OrderID' },
                { text: 'BOL', value: 'BillOfLading' },
                { text: 'L1', value: 'LoadNum' },
                { text: 'L2', value: 'LoadNumOrd' },
                { text: 'Terminal', value: 'TerminalName' },
                { text: 'Station', value: 'StationName' },
                { text: 'Customer', value: 'CustomerName' }
            ];
            this.filters = [
                'Date',
                'ShiftDetail',
                'DriverName',
                'OrderID',
                'BillOfLading',
                'TerminalName',
                'StationName',
                'CustomerName'
            ];
            if (this.Rate == true) {
                var Rate = [
                    { text: 'Kms', value: 'Kms' },
                    { text: 'DiesRate', value: 'DiesRate' },
                    { text: 'GasRate', value: 'GasRate' }
                ];
                await Rate.forEach(col => {
                    this.headers.push(col);
                });
                console.log(this.headers);
            }
            if (this.Product == true) {
                this.filters.push('Product');
                var Product = [
                    { text: 'Product', value: 'Product' },
                    { text: 'Dispatched Qty', value: 'DispatchedQuantity' },
                    { text: 'Delivered Qty', value: 'DeliveredQuantity' },
                    { text: 'TempAdj Qty', value: 'TempAdjQuantity' }
                ];
                await Product.forEach(col => {
                    this.headers.push(col);
                });
                console.log(this.headers);
            }
            if (this.InvPay == true) {
                this.filters.push('InvId');
                this.filters.push('PayId');
                var InvPay = [
                    { text: 'InvId', value: 'InvId' },
                    { text: 'InvDate', value: 'InvDate' },
                    { text: 'SplitsRev', value: 'SplitsRev' },
                    { text: 'RevMOQQty', value: 'RevMOQQty' },
                    { text: 'PayId', value: 'PayId' },
                    { text: 'PayDate', value: 'PayDate' },
                    { text: 'SplitPay', value: 'SplitPay' },
                    { text: 'PayMOQQty', value: 'PayMOQQty' }
                ];
                await InvPay.forEach(col => {
                    this.headers.push(col);
                });
                console.log(this.headers);
            }
        },
        report: function() {
            var str = this.$store;
            str.state.isLoading = true;
            this.show = true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                Station: this.station != null ? this.station.id : null,
                Terminal: this.terminal != null ? this.terminal.id : null,
                Driver: this.driver != null ? this.driver.id : null,
                Trailer: this.trailer != null ? this.trailer.id : null,
                Customer: this.customer != null ? this.customer.id : null,
                ProductType: this.productType  != null ? this.productType.ProductID : null,
                Rate: this.Rate,
                InvPay: this.InvPay,
                Product: this.Product,
                Truck: this.truck != null ? this.truck.TruckID : null
            };
            axios
                .post('order/dynamic/report', parms)
                .then(response => {
                    this.preview = response.data;
                    console.log(this.preview);
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        showtable: function() {
            console.log('Orden por:', this.sortBy);
            console.log('Orden descendente:', this.sortDesc);
            console.log('Datos ordenados:', this.preview);
        },
        reportDownload: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                Filtered: this.filteredItems
            };
            axios
                .post('order/create/dynamic/report', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Excel-Dynamic.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        updateSortBy(sortBy) {
            // Actualizar la propiedad 'sortBy' cuando se realiza el ordenamiento
            this.sortBy = sortBy;
            // Llamar a una función para ordenar el arreglo
            this.sortData();
        },
        updateSortDesc(sortDesc) {
            // Actualizar la propiedad 'sortDesc' cuando cambia la dirección del orden
            this.sortDesc = sortDesc;
            // Llamar a una función para ordenar el arreglo
            this.sortData();
        },
        sortData() {
            // Función para ordenar el arreglo en respuesta a los eventos de ordenamiento
            this.filteredItems.sort((a, b) => {
                const modifier = this.sortDesc ? -1 : 1;
                if (a[this.sortBy] < b[this.sortBy]) return -1 * modifier;
                if (a[this.sortBy] > b[this.sortBy]) return 1 * modifier;
                return 0;
            });
        }
    }
};
</script>
